import { render, staticRenderFns } from "./tiposdocumentos.vue?vue&type=template&id=6cb2adc7"
import script from "./tiposdocumentos.vue?vue&type=script&lang=js"
export * from "./tiposdocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports